module.exports = __webpack_public_path__ + "media/images/partnersgroup-6a5f386e.png";